module.exports = __webpack_public_path__ + "static/media/twoThirdImageRight.6f2a925f.png";